/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: intent.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateIntentRequest,
  CreateIntentResponse,
  ResolveIntentRequest,
  ResolveIntentResponse,
} from '../types/intent';

export const createIntentService = (transport: Transport) => ({
  async createIntent(
    request: CreateIntentRequest,
    options: RequestOptions = {},
  ): Promise<CreateIntentResponse> {
    const url = getApiPath(API_METHODS.IntentsService.CreateIntent);
    return transport.post<CreateIntentResponse>(url, request, options);
  },

  async resolveIntent(
    request: ResolveIntentRequest,
    options: RequestOptions = {},
  ): Promise<ResolveIntentResponse> {
    const { intent_id } = request;
    const url = getApiPath(API_METHODS.IntentsService.ResolveIntent, { intent_id });
    return transport.get<ResolveIntentResponse>(url, options);
  },
});

export type IntentService = ReturnType<typeof createIntentService>;
